export const Tier = ({ name, requirement, filled }) => (
    <div className="col-6 col-md-4">
      <div className="sf_left_box">
        <h5>{name}</h5>
        <p>Staking Requirement {requirement} BRAIN</p>
        <h6>{filled ? "FILLED" : "OPEN"}</h6>
      </div>
    </div>
  );